import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  padding: 0 54px;
`;

const Title = styled.div`
  box-shadow: none;
  font-size: 40px;
  font-weight: 900;
`;

const PageTitle = ({ title }) => {
  return (
    <Wrapper>
      <Title>{title}</Title>
    </Wrapper>
  );
};

export default PageTitle;
